<template>
  <button
    class="button"
    :type="type"
    :class="classes"
    :disabled="disabled"
    @click="handleClick"
  >
    <span v-if="hasIcon" class="button__icon">
      <slot name="icon"></slot>
    </span>
    <span v-if="$slots.default" class="button__text">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'VButton',

  props: {
    type: {
      type: String,
      default: 'button'
    },

    theme: String,
    disabled: Boolean,
    rounded: Boolean,
    view: String
  },

  computed: {
    hasIcon() { return this.$slots.icon },

    classes() {
      return [
        this.theme ? `button--${this.theme}` : '',
        this.view ? `button--${this.view}` : '',
        {
          'button--icon': this.hasIcon,
          'button--disabled': this.disabled,
          'button--rounded': this.rounded
        }
      ]
    }
  },

  methods: {
    handleClick(event) {
      if (this.disabled) return
      this.$emit('click', event)
    }
  }
}
</script>
